export default "__VITE_ASSET__88a84fea__"